.content {
  --floating-panel-width: 20rem;
  display: flex;
  flex-direction: column;
  width: min(var(--floating-panel-width), calc(100vw - 1.5rem));
  max-height: min(40rem, calc(100dvh - 1.5rem), var(--popover-available-height, 100dvh));
  overflow: hidden;
  padding: 0;

  &[data-width="compact"] {
    --floating-panel-width: 16rem;
  }

  &[data-width="wide"] {
    --floating-panel-width: 26rem;
  }

  &[data-width="extraWide"] {
    --floating-panel-width: 38rem;
  }
}

.header {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 0.75rem;
  padding: 0.875rem 1rem;
  border-bottom: 1px solid var(--color-border);
}

.title {
  min-width: 0;
  line-height: 1.2;
}

.description {
  margin-top: 0.125rem;
}

.body {
  min-height: 0;
  overflow-y: auto;
}

.section {
  min-width: 0;
  padding: 0.5rem;

  &[data-padding="form"] {
    padding: 1rem;
  }

  &[data-padding="none"] {
    padding: 0;
  }
}

.footer {
  padding: 0.5rem;
  border-top: 1px solid var(--color-border);
  background: var(--color-surface-subtle);
}

.action {
  width: 100%;
  min-height: 2.5rem;
  justify-content: flex-start;
  gap: 0.75rem;
  padding: 0.625rem 0.75rem;
  border-color: transparent;
  border-radius: var(--radius-md);
  background: transparent;
  color: var(--color-foreground);
  text-align: start;

  &:hover,
  &:focus-visible {
    background: var(--color-card-hover) !important;
  }

  &[data-selected="true"] {
    background: var(--color-primary-soft);
  }

  &[data-color="danger"] {
    color: var(--color-danger-text);

    .actionIcon {
      color: var(--color-danger-text);
    }
  }
}

.actionIcon {
  display: grid;
  width: 1.5rem;
  height: 1.5rem;
  flex: 0 0 auto;
  place-items: center;
  color: var(--color-muted);

  > svg {
    width: 1.125rem;
    height: 1.125rem;
  }
}

.actionText {
  display: flex;
  min-width: 0;
  flex: 1;
  flex-direction: column;
  gap: 0.125rem;
}

.actionMeta {
  display: grid;
  flex: 0 0 auto;
  place-items: center;
  color: var(--color-muted-foreground);

  > svg {
    width: 1rem;
    height: 1rem;
  }
}

.divider {
  margin: 0;
}
